import React, { useCallback } from 'react';
import { View } from 'react-native';
import Banner from '../Banner';
import Title from '../Title';
import marisaCardBackground from '~/assets/img/home/marisaCardBackground.png';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { isWeb } from '~/utils/device';
import marisaCards from '~/assets/img/home/marisaCards.png';
import mbankCardBackground from '~/assets/img/home/mbankCardBackground.png';
import marisaCard from '~/assets/img/home/marisaCard.png';
import mbankCard from '~/assets/img/home/mbankCard.png';
import useAppNavigation from '~/hooks/useAppNavigation';
import useCredsystemAuthStore from '~/credsystem/stores/credsystemAuth';
import Env from '~/env';

const Cards: React.FC = () => {
  const { navigate } = useAppNavigation();

  const handleOpenCredsystem = useCallback(() => {
    if (!useCredsystemAuthStore.getState().credsystemUserInfo) {
      return navigate('Credsystem_SignIn');
    }

    return navigate('Credsystem_Dashboard');
  }, [navigate]);

  const handleRequestCard = useCallback(() => {
    if (Env.MARISA_CARD_REQUEST) {
      window.open(Env.MARISA_CARD_REQUEST, '_blank');
    } else {
      console.error('Card request link is not defined');
    }
  }, []);

  const RenderContent = useCallback(() => {
    if (MarisaAppUtils.origin !== 'app') {
      return (
        <>
          <View className="w-full sm:flex-1">
            <Banner
              title="Cartão Marisa"
              description="Gerencie seu cartão Marisa com o App exclusivo"
              buttonLabel="ACESSAR"
              secondaryButtonLabel="SAIBA MAIS"
              thirdButtonLabel="SOLICITE SEU CARTÃO"
              image={marisaCardBackground}
              rightImage={marisaCard}
              fullWidth
              buttonWhite
              rightImageResizeMode={isWeb ? 'center' : 'contain'}
              onPressButton={handleOpenCredsystem}
              onPressSecondButton={() =>
                navigate('MarisaServicos_AboutMarisaCard')
              }
              onPressThirdButton={handleRequestCard}
            />
          </View>
          <View className="w-full sm:flex-1 my-4 sm:my-0 sm:ml-4 hidden">
            {!MarisaAppUtils.disableMbank && (
              <Banner
                title="Cartão Mbank"
                description="Gerencie as informações do seu cartão Mbank"
                buttonLabel="ACESSAR"
                image={mbankCardBackground}
                rightImage={mbankCard}
                fullWidth
                buttonWhite
                rightImageResizeMode={isWeb ? 'center' : 'contain'}
                onPressButton={MarisaAppUtils.goToMbank}
              />
            )}
          </View>
        </>
      );
    }

    return (
      <Banner
        title="Cartões Marisa"
        description="Gerencie as informações do seu cartão"
        buttonLabel="Acessar"
        secondaryButtonLabel="Saiba mais"
        image={marisaCardBackground}
        rightImage={marisaCards}
        fullWidth
        buttonWhite
        rightImageResizeMode={isWeb ? 'center' : 'contain'}
        onPressButton={MarisaAppUtils.goToMbank}
        onPressSecondButton={() => navigate('MarisaServicos_AboutMarisaCard')}
      />
    );
  }, [handleOpenCredsystem, handleRequestCard, navigate]);

  return (
    <View className="px-4 md:px-6 xl:px-0">
      <Title title="Cartões" />
      <View className="flex-col sm:flex-row flex-wrap justify-between sm:justify-start">
        <RenderContent />
      </View>
      <View>
        <Title title="Aproveite todos os nossos serviços feitos para você!" />
        <Banner
          title="Meus Seguros"
          description="Gerencie seus seguros Marisa contratados"
          buttonLabel="ACESSAR"
          image={mbankCardBackground}
          // rightImage={mbankCard}
          fullWidth
          buttonWhite
          rightImageResizeMode={isWeb ? 'center' : 'contain'}
          onPressButton={() => {
            if (Env.MY_INSURENCE) {
              navigate('MarisaServicos_Iframe', {
                url: Env.MY_INSURENCE,
              });
            } else {
              console.error('Marisa my insurance link is not defined');
            }
          }}
        />
      </View>
    </View>
  );
};

export default Cards;
